import { FeatureCategory } from '../types';

export const familyGuidesFeatures: FeatureCategory = {
  name: "Family Support & Guides",
  icon: "HeartHandshake",
  features: [
    {
      name: "Where Do I Start? (Care Blueprint)",
      description: "A guided experience that helps you sort your concerns, understand what's most important right now, and walk away with personalized next steps, not a to-do list, a real plan.",
      starter: "✔", max: "✔", family: "✔", careAddOn: ", "
    },
    {
      name: "Conversation Guide",
      description: "Scripts and prompts for the conversations nobody teaches you how to have, about safety, driving, finances, and future planning. Start the talk with confidence, not dread.",
      starter: "✔", max: "✔", family: "✔", careAddOn: ", "
    },
    {
      name: "Meaningful Call Prompts",
      description: "Quick conversation starters that turn routine phone calls into moments of real connection, so you're not just checking in, you're catching up.",
      starter: "✔", max: "✔", family: "✔", careAddOn: ", "
    },
    {
      name: "Memory Spark",
      description: "Gentle prompts that spark memories and shared stories between you and your loved one. A simple way to reconnect across the years.",
      starter: "✔", max: "✔", family: "✔", careAddOn: ", "
    },
    {
      name: "Harmony Guide",
      description: "When family members disagree about care decisions, this guide helps you find alignment, reducing stress and keeping everyone focused on what matters.",
      starter: "✔", max: "✔", family: "✔", careAddOn: ", "
    }
  ]
};
